import React, { useState } from "react";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";
import { TextField, Button, Paper, Box, Typography } from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  onCreated: (client: any) => void;
};

const AddCustomerModal: React.FC<Props> = ({ open, onClose, onCreated }) => {
  const { token } = useAuth();
  const [form, setForm] = useState({ fullName: "", email: "", phone: "", address: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!open) return null;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const res = await api.post("/clients", form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      onCreated(res.data?.client || res.data);
      setForm({ fullName: "", email: "", phone: "", address: "" });
    } catch (err: any) {
      setError(err?.response?.data?.message || "Failed to add customer");
    } finally {
      setSaving(false);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <Paper className="animate-fadein" sx={{ p: 3, width: "100%", maxWidth: 560 }}>
        <Typography variant="h6" fontWeight={800} mb={2}>Add New Customer</Typography>
        {error && <div className="text-red-600 mb-2">{error}</div>}
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 1.5 }}>
          <TextField name="fullName" label="Full Name" required value={form.fullName} onChange={handleChange} disabled={saving} />
          <TextField name="email" type="email" label="Email" value={form.email} onChange={handleChange} disabled={saving} />
          <TextField name="phone" label="Phone" value={form.phone} onChange={handleChange} disabled={saving} />
          <TextField name="address" label="Address" value={form.address} onChange={handleChange} disabled={saving} />
          <Box sx={{ display: "flex", justifyContent: "end", gap: 1 }}>
            <Button type="button" variant="outlined" onClick={onClose} disabled={saving}>Cancel</Button>
            <Button type="submit" variant="contained" disabled={saving}>{saving ? "Saving..." : "Add Customer"}</Button>
          </Box>
        </Box>
      </Paper>
      <style>{`
        .animate-fadein { animation: fadein .12s ease both }
        @keyframes fadein { 0% {opacity:0;transform:scale(.95)} 100% {opacity:1;transform:scale(1)} }
      `}</style>
    </div>
  );
};

export default AddCustomerModal;
